export const apiUrl = window.config?.backendUrl || 'http://localhost:5000';
